import React from 'react'
import styled from 'styled-components'
import Plaatjie from '@ubo/plaatjie'
import ParseContent from '../shared/ParseContent'
import ButtonDefault from './ButtonDefault'
import { mainTheme } from '../../styles/Theme'

const CtaSection = styled.section`
  @media (min-width: 992px) {
    margin-top: 6rem;
    margin-bottom: 12rem;
  }

  @media (max-width: 991.98px) {
    margin-bottom: 6rem;
  }
`

const Cta = styled.div`
  position: relative;
  background-color: #d50033;
  color: #fff;

  > div {
    padding-block: 3rem;
  }

  & p {
    font-size: 20px;
  }

  & .background-extender {
    position: absolute;
    height: 100%;
    width: 2000px;
    top: 0;
    right: 100%;
    background-color: #d50033;
  }

  & .cta-button {
    max-width: 200px;
    font-size: 16px;
  }

  @media (min-width: 992px) {
    > div {
      padding-right: 15rem;
    }
  }
`

const CtaImageWrapper = styled.div`
  position: relative;
  top: 2rem;

  @media (min-width: 992px) {
    margin-left: -8rem;
  }

  @media (max-width: 991.98px) {
    max-width: 300px;
    margin: 0 auto;
    order: -1;
  }
`
function CtaDefault({ cta }) {
  return (
    <CtaSection>
      <div className="container">
        <div className="row">
          <Cta className="col-lg-9">
            <div className="background-extender" />
            <div>
              <ParseContent content={cta.description} />
              <ButtonDefault
                wedgeColor={mainTheme.color.contrast}
                black
                to={cta.link.url}
                className="mt-lg-4 cta-button"
              >
                {cta.link.title}
              </ButtonDefault>
            </div>
          </Cta>
          <CtaImageWrapper className="col-lg-3">
            <Plaatjie image={cta.image} />
          </CtaImageWrapper>
        </div>
      </div>
    </CtaSection>
  )
}

export default CtaDefault
